import React from 'react'

import { string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

// Copied from LegacyNavigation's UserGdprMessage, restyled for the new dropdown.
// Shown at the top of the menu when the user has not decided on notification
// consent, nudging them to review their email preferences. The anchor is
// interpolated via {{link}} so translators can position it per grammar; i18next
// runs with escapeValue off, so the (developer-authored, no user input) anchor
// HTML passes through unescaped.
const NOTIFICATIONS_SETTINGS_URL = '/profile/settings#tab-settings-notifications'

function GdprNotice({ locale = 'en' }) {
  const linkText = i18n.t('navigation.user_menu.gdpr_notice.link', { ns: 'rails', lng: locale })
  const link = `<a href="${NOTIFICATIONS_SETTINGS_URL}" class="unified-nav__dropdown-notice-link">${linkText}</a>`
  const html = i18n.t('navigation.user_menu.gdpr_notice.message', { ns: 'rails', lng: locale, link })

  return (
    <div
      className="unified-nav__dropdown-notice cgt-body-base-semibold"
      // Translated copy + a static in-app URL, no user input - safe to inject.
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}

GdprNotice.propTypes = {
  locale: string,
}

export default GdprNotice
